import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { Platform } from '@ionic/angular/lazy';
import { NATIVE_MOBILE_PLATFORM } from '../app.constants';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  readonly #platform = inject(Platform);
  readonly #router = inject(Router);

  public async setUserId(userId: string) {
    if (this.#platform.is(NATIVE_MOBILE_PLATFORM)) {
      await FirebaseAnalytics.setUserId({ userId });
    }
  }

  public async setUserProperty(key: string, value: string) {
    if (this.#platform.is(NATIVE_MOBILE_PLATFORM)) {
      await FirebaseAnalytics.setUserProperty({ key, value });
    }
  }

  public async setScreenName(screenName: string, screenClassOverride?: string) {
    if (this.#platform.is(NATIVE_MOBILE_PLATFORM)) {
      await FirebaseAnalytics.setCurrentScreen({
        screenName,
        screenClassOverride,
      });
    }
  }

  public async logEvent(name: string, params?: object) {
    if (this.#platform.is(NATIVE_MOBILE_PLATFORM)) {
      await FirebaseAnalytics.logEvent({ name, params });
    }
  }

  public async setEnabled(enabled: boolean) {
    if (this.#platform.is(NATIVE_MOBILE_PLATFORM)) {
      await FirebaseAnalytics.setEnabled({ enabled });
    }
  }

  public trackPageChanges() {
    this.#router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentPath = event.urlAfterRedirects;
        // anonymize uuids
        const anonymizedPath = currentPath.replace(/\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi, 'uuid');
        this.setScreenName(anonymizedPath);
      }
    });
  }
}
